export default [{
  path: '/indexAct',//活动预览表
  name: 'ActPage',
  component: () => import('@/view/indexSpa/activity.vue')
},{
  path: '/indexActList',//活动预览表列表
  name: 'ActListPage',
  component: () => import('@/view/indexSpa/actList.vue')
},{
  path: '/indexSeminar',//系列研讨会
  name: 'SeminarPage',
  component: () => import('@/view/indexSpa/seminar.vue')
},
// {
//   path: '/indexSeminarList',//系列研讨会列表
//   name: 'SeminarListPage',
//   component: () => import('@/view/indexSpa/seminarList.vue')
// },
{
  path: '/indexSeminarDet',//系列研讨会详情
  name: 'SeminarDetPage',
  // component: () => import('@/view/indexSpa/seminarDet.vue')
  component: () => import('@/view/ForumSpa/meetDet.vue')
},
{
  path: '/indexTraffic',//交通服务
  name: 'TrafficPage',
  component: () => import('@/view/indexSpa/traffic.vue')
},{
  path: '/indexData',//数据统计
  name: 'dataIndexPage',
  component: () => import('@/view/indexSpa/data.vue')
},{
  path: '/indexHotel',//找酒店
  name: 'Hotel',
  component: () => import('@/view/indexSpa/hotel.vue')
},
// {
//   path: '/indexHotelList',//找酒店
//   name: 'HotelList',
//   component: () => import('@/view/indexSpa/hotelList.vue')
// },
{
  path: '/indexHotelDet',//找酒店详情
  name: 'HotelDetail',
  component: () => import('@/view/indexSpa/hotelDetail.vue')
},{
  path: '/indexGuest',//历届嘉宾
  name: 'guestPage',
  component: () => import('@/view/indexSpa/guest.vue')
},{
  path: '/indexGuestDet',//历届嘉宾-详情
  name: 'guestDetPage',
  component: () => import('@/view/indexSpa/guestDetail.vue')
},{
  path: '/indexHisGuest',//历届嘉宾-详情
  name: 'HisGuest',
  component: () => import('@/view/indexSpa/HisGuest.vue')
},{
  path: '/indexVolunteer',//志愿服务首页
  name: 'volunteerPage',
  component: () => import('@/view/indexSpa/volunteer.vue')
},{
  path: '/indexVolunteerMore',//志愿者搜索
  name: 'volunteerMorePage',
  component: () => import('@/view/indexSpa/volunteerMore.vue')
},
// {
//   path: '/indexVolunteerMoreList',//志愿者搜索列表
//   name: 'volunteerMoreListPage',
//   component: () => import('@/view/indexSpa/volunteerMoreList.vue')
// },
{
  path: '/indexVolunteerReg',//志愿者注册
  name: 'volunteerRegPage',
  component: () => import('@/view/indexSpa/volunteerReg.vue')
},{
  path: '/indexPicDet',//展区内容详情
  name: 'PicDetIPage',
  component: () => import('@/view/indexSpa/picDet.vue')
},{
  path: '/indexNewsDet',//新闻详情
  name: 'newsDetIPage',
  component: () => import('@/view/indexSpa/newsDet.vue')
},
]




// WEBPACK FOOTER //
// ./src/router/indexSpa.js